type DomInvalidationOwner = Readonly<{
    invalidateDom(): void;
}>;

const owners = new WeakMap<Element, Set<DomInvalidationOwner>>();

const registerDomInvalidationOwner = (
    element: Element,
    owner: DomInvalidationOwner,
): (() => void) => {
    const elementOwners = owners.get(element) ?? new Set<DomInvalidationOwner>();
    elementOwners.add(owner);
    owners.set(element, elementOwners);
    return () => {
        elementOwners.delete(owner);
        if (elementOwners.size === 0) owners.delete(element);
    };
};

const findClosestDomInvalidationOwners = (element: Element): readonly DomInvalidationOwner[] => {
    let current: Element | null = element;
    while (current) {
        const elementOwners = owners.get(current);
        if (elementOwners?.size) return Array.from(elementOwners);
        current = current.parentElement;
    }
    return [];
};

export {findClosestDomInvalidationOwners, registerDomInvalidationOwner};
export type {DomInvalidationOwner};
